<script setup lang="ts">
import NewsletterSubscription from './../shared/NewsletterSubscription.vue'
</script>

<template>
  <div class="bx-teaser-container bx-teaser-container--newsletter">
    <div class="bx-teaser-container__inner-wrapper">
      <NewsletterSubscription
        usage="teaser" />
    </div>
  </div>
</template>
